import type { TiptapState } from '@/types';
import { produce } from 'immer';
import { getTableOfContents } from '../components/nodes/tableOfContents';

// Process Table of Contents
function processPostTOC(state: TiptapState): TiptapState {
  const tocData = getTableOfContents(state);

  return produce(state, (draft) => {
    const updateTocBlocks = (node: any) => {
      // If this is a tableOfContents block, update its content
      if (node.type === 'tableOfContents') {
        node.attrs.data = tocData;
      }

      // Recursively process any nested content
      if (node.content && Array.isArray(node.content)) {
        node.content.forEach(updateTocBlocks);
      }
    };

    // Start the recursive search from the root content
    if (draft.content && Array.isArray(draft.content)) {
      draft.content.forEach(updateTocBlocks);
    }
  });
}

export { processPostTOC };
